module.exports = __webpack_public_path__ + "static/about-investition8-2275ca1d5f9482d83c122610d1ad59ef.jpg";